import type { TriState } from '@/components/TriStateCheckbox';

export interface CategoryCell {
  state: TriState;
  blockedBy?: string;
}

export interface ProductCell {
  state: TriState;
  blockedBy?: string;
  viaCategory?: boolean;
}

export function deriveCategoryCell(input: {
  ownsWholeCategory: boolean;
  ownProductCount: number;
  otherCategoryOwner?: string;
  otherProductOwner?: string;
}): CategoryCell {
  if (input.ownsWholeCategory) return { state: 'checked' };
  if (input.ownProductCount > 0) return { state: 'partial' };
  if (input.otherCategoryOwner) return { state: 'blocked', blockedBy: input.otherCategoryOwner };
  if (input.otherProductOwner) return { state: 'blocked', blockedBy: input.otherProductOwner };
  return { state: 'empty' };
}

export function deriveProductCell(input: {
  categoryChecked: boolean;
  ownsProduct: boolean;
  otherProductOwner?: string;
  otherCategoryOwner?: string;
}): ProductCell {
  if (input.categoryChecked) return { state: 'checked', viaCategory: true };
  if (input.ownsProduct) return { state: 'checked' };
  const owner = input.otherProductOwner ?? input.otherCategoryOwner;
  if (owner) return { state: 'blocked', blockedBy: owner };
  return { state: 'empty' };
}
